let space = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'

export default{
  top1: '概览',
  top2: '技术规格',
  dec: '高清八镜头  精准复刻空间',
  yushou: '【早鸟价】',
  price: 'RMB 9,800',
  addzhijia: 'RMB 10,395',
  buy: '立即购买',
  why: '为什么要购买容量？',
  tiaokuan: '* 付款成功后5个工作日内发货，默认顺丰快递包邮',
  guige: {
    name: '技术规格',
    dec: '注：本页面所列配置及参数均以实际上市产品为准，如有变更，恕不另行通知。',
    arr: [
      {
        name: '机身尺寸',
        val: [`高度：220.7mm${space}宽度：78.2mm${space}厚度：78.2mm`]
      },
      {
        name: '镜头',
        val: [
          `类型：200°鱼眼镜头${space}孔径：f/2.0${space}数量：8个${space}<br/>分辨率：4608*3456像素（每个）；8192*4096像素（合计）`
        ]
      },
      {
        name: '传感器',
        val: [`范围：1/2.3英寸${space}数量：8个`]
      },
      {
        name: '存储内存',
        val: [
          '16GB'
        ]
      },
      {
        name: '电池',
        val: [
          `7.4V 4200mAh${space}可通过USB快速充电`
        ]
      },
      {
        name: 'WiFi',
        val: [
          `802.11a/b/g/n网络协议${space}支持2.4/5GHz通信`
        ]
      },
      {
        name: '设备接口',
        val: [
          'TYPE C'
        ]
      }
    ]
  },
  color: {
    key: '颜色',
    val: '静谧黑'
  },
  service: {
    type: '容量套餐（10G）',
    key: '服务',
    val: [
      '支持分享多个社交平台',
      '最高支持6M/s上传',
      '支持在3D空间中增加多媒体热点、隐私加密、自动测距、嵌入网站等功能'
    ]
  },
  gift: {
    peijian: '配件',
    key: '了解配件详情',
    val: '四维看看 Pro三脚架套装',
    price: 'RMB：899'
  },
  count: {
    key: '数量'
  },
  pricename: '云容量套餐',
  pricename1: '云容量套餐（海外版）',
  pricelist: {
    0: '类型',
    1: '容量套餐',
    2: '价格',
    3: '包月',
    4: '包年',
    5: '基础容量',
    6: '10G',
    7: '—',
    8: '扩充容量',
    9: '20G',
    10: '50G',
    11: '200G',
    12: '1T',
    13: '￥129 / 月',
    14: '￥509 / 月',
    15: '￥2399 / 月',
    16: '￥12599 / 月',
    17: '￥1290 / 年',
    18: '￥5090 / 年',
    19: '￥23990 / 年',
    20: '￥125990 / 年',
    '13hw': '$19 / 月',
    '14hw': '$76 / 月',
    '15hw': '$349 / 月',
    '16hw': '$1799 / 月',
    '17hw': '$190 / 年',
    '18hw': '$760 / 年',
    '19hw': '$3490 / 年',
    '20hw': '$17990 / 年',
    21: '需求1T以上，请联络客服'
  },
  pricetxt: [
    {
      q: '为什么需要云容量？',
      a:
        '答：四维看看3D相机的计算方式不同于常规2D相机，其计算结果暂不支持本地保存。<br/>因为四维看看的AI空间重构算法系统需要庞大的计算资源支持，若要快速地满足该计算资源，本地端可能需要部署数万元的主机，所以我们将其安排在云端开展计算。既可满足降低成本的需求，享受企业级安全的云存储服务，同时计算结果可在多端口（移动端、网页端、IPAD端、VR端）无插件浏览。'
    },
    {
      q: '为什么需要额外购买容量？',
      a:
        '答：相机基础云容量为10G，可拍摄约10个三维场景。（以每个场景200㎡计算）<br/>当相机附赠的基础容量满足不了您的数据需求时，需要额外购买的流量，通过容量扩充可以获得更大的存储空间，从而拍摄、上传、计算、浏览更多的场景数据。<br/>三维场景和模型的生成和保存需要消耗大量的计算资源和存储资源，这些资源单纯依靠相机自带的硬件设备是无法满足需求的，海量数据运算和存储的工作是在对象存储 OSS的公有云上进行的。当您计算并保存更多的三维场景时，会消耗更多的云上资源，所以扩充的容量是有偿提供的。'
    },
    {
      q: '容量计费的依据来源？',
      a: `答：四维看看是AI空间重构系统部署于阿里云OSS的云计算服务器上，同时租赁了云存储服务。<br/>根据阿里云OSS云存储服务的官方报价，1GB的模型数据，在每月被浏览约160次的条件下，费用为12元，此外还需另计模型云计算费用和请求费用等额外费用。<br/>四维看看的扩充容量计费标准基本与阿里云收费持平，1GB每月单价约为13元。`
    }],
  notice: '我们的最终容量售价是综合以上成本核算出的公平、合理结果。',
  view: '查看详细相机扩容计费方案。',
  qa: [
    {
      q: '为什么需要云容量？',
      a:
        `答：四维看看3D相机的计算方式不同于常规2D相机，其计算结果暂不支持本地保存。<br/>
        因为四维看看的AI空间重构算法系统需要庞大的计算资源支持，若要快速地满足该计算资源，本地端可能需要部署数万元的主机，所以我们将其安排在云端开展计算。既可满足降低成本的需求，享受企业级安全的云存储服务，同时计算结果可在多端口（移动端、网页端、IPAD端、VR端）无插件浏览。`
    },
    {
      q: '为什么需要额外购买容量？',
      a:
        `答：相机基础云容量为10G，可拍摄约10个三维场景。（以每个场景200㎡计算）<br/>
        当相机附赠的基础容量满足不了您的数据需求时，需要额外购买的流量，通过容量扩充可以获得更大的存储空间，从而拍摄、上传、计算、浏览更多的场景数据。<br/>
        三维场景和模型的生成和保存需要消耗大量的计算资源和存储资源，这些资源单纯依靠相机自带的硬件设备是无法满足需求的，海量数据运算和存储的工作是在对象存储 OSS的公有云上进行的。当您计算并保存更多的三维场景时，会消耗更多的云上资源，所以扩充的容量是有偿提供的。`
    },
    {
      q: '容量计费的依据来源？',
      a: `答：四维看看是AI空间重构系统部署于阿里云OSS的云计算服务器上，同时租赁了云存储服务。<br/>
      根据阿里云OSS云存储服务的官方报价，1GB的模型数据，在每月被浏览约160次的条件下，费用为12元，此外还需另计模型云计算费用和请求费用等额外费用。<br/>
      四维看看的扩充容量计费标准基本与阿里云收费持平，1GB每月单价约为13元。`
    },
    {
      q: '什么是基础容量？什么是扩充容量（容量套餐）？ ',
      a:
        `答：基础容量是购买相机时的附赠容量，目前预购用户附赠大小为10G；扩充容量（容量套餐）是指当相机附赠的基础容量满足不了您的数据需求时，需要额外购买的流量。通过容量扩充可以获得更大的存储空间，从而拍摄、上传、计算、浏览更多的场景数据。`
    },
    {
      q: '如何扩充容量？',
      a: `答：当您完成注册并绑定相机后，可以依次进入【个人中心（点击右上角用户头像进入）】——【我的相机】——【扩容】，完成相机的扩容。相机APP亦可进入【我的】——【扩容】，进行扩容。`
    },
    {
      q: '扩充容量的期限有何限制？',
      a: `答：当您成功购买容量套餐后，扩充容量立即生效。容量套餐的有效期为一年或一个月，包年容量有效期按照365天进行计算，包月容量有效期按照31天进行计算。<br/>
      当购买一个容量套餐时，如：<br/>
      您于2019年8月26日购买了一年的容量套餐，则可使用至2020年8月25日23:59。`
    },
    {
      q: '同一套餐的容量能否重复购买？',
      a:
        `答：不可以。同一容量套餐的购买只能选择续期，如您需要更大的容量套餐，您可升级更大的容量套餐。`
    },
    {
      q: '不同套餐的容量能否组合购买？',
      a:
        `答：不可以。如您需要更大的容量套餐，您可升级更大的容量套餐。`
    },
    {
      q: '假如升级套餐，原套餐的剩余时间怎么办？',
      a:
        `答：原套餐的剩余时间将换算为新套餐的时间，体现为延期时间。<br/>
        计算公式为：以每月129元的20G套餐为准，其中10G为基础容量不计算，换算的单位价值约为：0.42元/天/GB。<br/>
        如您原套餐为20G套餐（月），还有10天到期，则计算剩余为42元。<br/>
        当天您升级套餐为50G套餐（月），其费用为509元/月（单天价值为16.4元）。<br/>
        原套餐剩余价值约为新套餐单天价值的2.6倍，则新套餐延期时间为3天。<br/>
        （延期计费方式采用进一法：1.01~1.99倍数都视作2倍。）`
    },
    {
      q: '容量套餐可以降级吗？ ',
      a:
        `答：暂不支持降级处理。即50G套餐/月，无法通过点击“升级套餐”的方式，选择20G套餐/月进行“升级”或续期。如您的扩容容量超过1TB，请联络客服。`
    },
    {
      q: '扩充容量到期后，超出容量的场景会如何处理？',
      a:
        `答：当您已购买的扩充容量到期后，到期的容量将被回收。<br/>
        容量回收后，若您的场景数据量小于或等于基础容量（10G），则场景不受任何影响。<br/>
        容量回收后，若您的场景数据量超出当前容量，超出基础容量部分的场景不会被删除，但会被封存，即查看、编辑和分享等功能暂不可用。未被封存的大场景不受任何影响，封存的顺序按照场景生成的时间倒序排列，即最近生成的场景最先被封存，封存场景数据保存期为一年。`
    },
    {
      q: '超出容量了还可继续拍摄上传吗？ ',
      a:
        `答：超出容量时，不影响设备正常的拍摄和上传，但新上传的场景会被封存，直到您可使用的存储容量大于等于全部场景数据量，才能解封最新上传场景。`
    },
    {
      q: '封存场景如何解封？  ',
      a:
        `答：当您继续购买或升级容量套餐，至存储容量大于等于全部场景数据量时，可实现封存场景的解封。除此之外，通过删除历史场景也可实现封存场景的解封，删除的场景将不会被恢复。`
    }
  ],
  directions: '说明：',
  read1: '以上说明内容及收费标准，可能会根据第三方云存储的费用变化或运营政策而调整。',
  read2: '如有调整，将于官网公布，恕不另行通知。',
  introduce: {
    deviceId: '设备ID：',
    taocan: '',
    used: '已使用：',
    belong: '容量构成：',
    scence: '我的场景',
    buyType: '请选择要购买的套餐种类',
    mounthly: '1个月',
    _3month: '3个月',
    half: '6个月',
    year: '1年',
    buy: '升级套餐',
    nyear: '年',
    nmounth: '月',
    fixpre: {
      month: '月',
      year: '年',
      _3mon: '3个月',
      half: '6个月'
    },
    spaceContent: '四维看看Pro八目相机基础容量',
    ctype: {
      '10GB': '可存放约10个场景',
      '20GB': '可存放约20个场景',
      '50GB': '可存放约50个场景',
      '50G': '可存放约50个场景',
      '200GB': '可存放约200个场景',
      '1TB': '可存放约1000个场景'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/purchase.js